import * as React from 'react';

import {Button} from 'shells/button/button';
import {EntityPill} from 'shells/entity-pill/entity-pill';
import {Percentage} from 'shells/percentage/percentage';
import {PopoverInfo} from 'shells/popover-info/popover-info';
import {Rating} from 'shells/rating/rating';
import {TwoLineInfo} from 'shells/two-line-info/two-line-info';

import type {CtCtContact as CtCtContactFragment} from 'nutshell-graphql-types';

import {AddToConstantContact} from './add-to-constant-contact';
import {ConstantContactActivity} from './constant-contact-activity';
import {SyncStatus} from './sync-status';

import styles from './constant-contact-details.module.css';

type Props = {
    entityId: string;
    ctctContact: CtCtContactFragment;
    entityName: string;
};

export function ConstantContactDetails(props: Props) {
    const {entityId, ctctContact, entityName} = props;

    return (
        <div>
            <div className={styles['two-line-info-wrapper']}>
                <TwoLineInfo
                    label='Lists'
                    mainAction={
                        <div className={styles.addButton}>
                            <AddToConstantContact
                                entityId={entityId}
                                buttonText='+ Add to a list'
                                onSuccess={() => {
                                    /* Noop to avoid showing popover */
                                }}
                            />
                        </div>
                    }
                >
                    {ctctContact.listMemberships.length ? (
                        ctctContact.listMemberships.map((list) => {
                            return (
                                <EntityPill
                                    key={list.id}
                                    isSmall={true}
                                    name={list.name}
                                    type='default'
                                />
                            );
                        })
                    ) : (
                        <i>Not in any lists</i>
                    )}
                </TwoLineInfo>
            </div>
            <div className={styles['engagement-stats']}>
                <TwoLineInfo
                    label={
                        <div>
                            Rating{' '}
                            <div className={styles['help-container']}>
                                <PopoverInfo
                                    size={14}
                                    info='Nutshell determines a person’s engagement rating based on how often they’re
                    interacting with your emails from Constant Contact.'
                                />
                            </div>
                        </div>
                    }
                >
                    {ctctContact.engagementRating ? (
                        <div className='flex align-center'>
                            <Rating
                                score={ctctContact.engagementRating}
                                title='Engagement rating'
                            />
                        </div>
                    ) : (
                        // TODO jank placeholder -- better handle a null engagementRating
                        <i>No rating</i>
                    )}
                </TwoLineInfo>
                <TwoLineInfo label='Emails sent' rightAligned={true}>
                    {ctctContact.sendsCount}
                </TwoLineInfo>
                <TwoLineInfo label='Open rate' rightAligned={true}>
                    {/* @ts-expect-error */}
                    <Percentage value={ctctContact.openRate} />
                </TwoLineInfo>
                <TwoLineInfo label='Click rate' rightAligned={true}>
                    {/* @ts-expect-error */}
                    <Percentage value={ctctContact.clickRate} />
                </TwoLineInfo>
            </div>
            <div className={styles['two-line-info-wrapper']}>
                <TwoLineInfo
                    label='Latest interaction'
                    mainAction={
                        ctctContact.latestActivity ? (
                            <Button variant='text-primary' onClick={scrollToTimeline}>
                                See all activity
                            </Button>
                        ) : null
                    }
                >
                    {/* @ts-expect-error */}
                    <ConstantContactActivity
                        activity={ctctContact.latestActivity}
                        entityName={entityName}
                    />
                </TwoLineInfo>
            </div>
            <SyncStatus ctctContact={ctctContact} entityId={entityId} />
        </div>
    );
}

function scrollToTimeline() {
    const filterButton = document.querySelector('.action-filterEntries.type-constant-contact');

    if (!filterButton) return;

    if (!filterButton.classList.contains('state-active')) {
        // @ts-expect-error
        filterButton.click();
    }

    filterButton.scrollIntoView();
}
